<template>
  <div v-show="config.show" v-finger:swipe="onSwipe" class="my-container works-container">
    <div v-show="!isDesktop" class="header">
      <div class="left">
        &nbsp;
      </div>
      <div class="middle">
        <el-dropdown trigger="click" placement="bottom" @command="(classid) =>emit('gotoWorks', [classid, 'best', 1])">
          <el-button style="width: 125px;padding: 0 8px;">{{ currentWorkClass.label }} <i class="iconfont my-open-down size14 float-right" /></el-button>
          <el-dropdown-menu slot="dropdown" class="my-dropdown">
            <el-dropdown-item v-for="(workClass, idx) in worksClass" :key="idx" :command="workClass.classid" :icon="workClass.icon" class="iconfont" :class="{ 'bg-blue': workClass.checked }">{{ workClass.label }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="right" />
    </div>
    <div v-if="isDesktop" class="works-class margin-top8 align-center">
      <el-row>
        <el-col v-for="(workClass, idx) in worksClass" :key="idx" :span="6">
          <div class="btn-col" :class="{ 'active': workClass.checked }" @click="emit('gotoWorks', [workClass.classid, 'best', 1])">
            <span class="tap-btn iconfont size24 box40" :class="workClass.icon" /><div class="margin-top8 size12">{{ workClass.label }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="tabs" :style="isDesktop ? 'top: 118px' : ''">
      <el-col :span="16">
        <el-tabs v-model="config.type">
          <el-tab-pane v-for="(type, idx) in types" :key="idx" :label="type[1]" :name="type[0]" />
        </el-tabs>
      </el-col>
      <el-col :span="8" class="filter">
        <el-button class="tap-btn" @click="emit('openSift', ['works'])">
          {{ config.catalogName }}
          <i class="iconfont my-filter" />
        </el-button>
      </el-col>
    </div>
    <works-list
      v-show="config.show && config.type === 'new'"
      ref="works-new"
      mod="new"
      :view="view"
      :state="state"
      :login-status="loginStatus"
      :login-user-id="loginUserId"
      @receive="handle"
    />
    <works-list
      v-show="config.show && config.type === 'hot'"
      ref="works-hot"
      mod="hot"
      :view="view"
      :state="state"
      :login-status="loginStatus"
      :login-user-id="loginUserId"
      @receive="handle"
    />
    <works-list
      v-show="config.show && config.type === 'best'"
      ref="works-best"
      mod="best"
      :view="view"
      :state="state"
      :login-status="loginStatus"
      :login-user-id="loginUserId"
      @receive="handle"
    />
    <works-list
      v-show="config.show && config.type === 'original'"
      ref="works-original"
      mod="original"
      :view="view"
      :state="state"
      :login-status="loginStatus"
      :login-user-id="loginUserId"
      @receive="handle"
    />
  </div>
</template>
<script>
import worksList from '@/components/web/worksList'
import { mixins } from '@/mixins/common'
import conf from '@/js/conf/conf'
export default {
  components: {
    worksList
  },
  mixins: [mixins],
  data() {
    const data = {}
    return data
  },
  computed: {
    config() {
      return this.view.works
    },
    types() {
      return this.config.types()
    },
    currentWorkClass() {
      return this.worksClass.find(workClass => workClass.classid === this.config.classid) || { label: '' }
    },
    worksClass() {
      const worksClass = conf.workClasses()
      worksClass.forEach(workClass => {
        workClass.checked = workClass.classid === this.config.classid
      })
      return worksClass
    }
  },
  methods: {
    handle(act, data) {
      this.emit(act, data)
    },
    onSwipe(evt) {
      this.switchTab(this.config, evt.direction)
    },
    renewView() {
      const el = this.$refs['works-' + this.config.type]
      if (el) el.renewView()
      this.$forceUpdate()
    }
  }
}
</script>
